import { render, staticRenderFns } from "./StepMeningitisB3.vue?vue&type=template&id=2c70879c&"
import script from "./StepMeningitisB3.vue?vue&type=script&lang=js&"
export * from "./StepMeningitisB3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports